import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    _initdata: {},
    _description: {},
    _history: []
  },
  mutations: {
    setData(state, object) {
      state._initdata = object
    },
    setDes(state, object) {
      state._description = object
    },
    setHis(state, array) {
      state._history = array
    }
  },
  actions: {
    setData({
      commit
    }, object) {
      commit('setData', object)
    },
    setDes({
      commit
    }, object) {
      commit('setDes', object)
    },
    setHis({
      commit
    }, object) {
      commit('setHis', object)
    }
  }
})
